import client from './client';

// List all active API keys for an org (never returns the raw key)
export const listApiKeys = (orgId) =>
  client.get(`/api/orgs/${orgId}/api-keys`);

// Create a new API key — response includes one-time `key` field
export const createApiKey = (orgId, name) =>
  client.post(`/api/orgs/${orgId}/api-keys`, { name });

// Revoke (delete) an API key by id
export const revokeApiKey = (orgId, keyId) =>
  client.delete(`/api/orgs/${orgId}/api-keys/${keyId}`);
